import { render, staticRenderFns } from "./help-chat.vue?vue&type=template&id=6ee3ec69&scoped=true"
import script from "./help-chat.vue?vue&type=script&lang=js"
export * from "./help-chat.vue?vue&type=script&lang=js"
import style0 from "./help-chat.vue?vue&type=style&index=0&id=6ee3ec69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3ec69",
  null
  
)

export default component.exports